import { TRY, NUM, fmtDate } from "@/lib/format";
import { cn } from "@/lib/utils";

export const LatestBadge = ({ className }) => (
  <span className={cn("inline-flex items-center rounded px-1.5 text-[9.5px] font-black tracking-wider bg-emerald-600 text-white leading-4", className)}>EN SON</span>
);

/** Önceki alışların fiyatları (en yeni hariç), en yeniden eskiye. */
export function PriceHistory({ occs, unit, max = 4, testid }) {
  const prev = (occs || []).slice(1, 1 + max);
  if (!prev.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1 mt-1" data-testid={testid}>
      <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Önceki alışlar</span>
      {prev.map((o) => (
        <span key={`${o.incoming_id}:${o.index}`} className="text-[10.5px] rounded border bg-muted/50 px-1.5 leading-4 tabular-nums whitespace-nowrap" title={`${o.belge_no} · ${NUM(o.quantity)} ${unit} alındı`}>
          {fmtDate(o.date)} · <b>{TRY(o.net_unit)}</b> · {NUM(o.quantity)} {unit}
        </span>
      ))}
      {occs.length > 1 + max && <span className="text-[10px] text-muted-foreground">+{occs.length - 1 - max}</span>}
    </div>
  );
}
